import { Enum } from "./Enum";

export const OrderHistoryTypeEnum: Enum[] = [
    { id: "notice", name: "Notice" },
    { id: "payment", name: "Payment" },
    { id: "shipping", name: "Shipping" },
    { id: "customer", name: "Customer" },
]